const footerLinks = {
  热门专题: ['台北娜娜爆料', '莫里秀黑料', '玩偶姐姐视频', '暗网人物专题', '每日吃瓜更新'],
  关于我们: ['关于51暗网吃瓜', '内容来源说明', '隐私保护', '免责声明'],
  联系方式: ['爆料投稿', '商务合作', '友情链接'],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <span className="text-xl font-heading font-bold text-primary-500 gossip-text-glow">
              51暗网吃瓜
            </span>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              聚焦51吃瓜旗下热门人物，提供台北娜娜、莫里秀、玩偶姐姐等独家爆料与视频内容。暗网吃瓜人物专题每日更新，为你带来最新鲜的吃瓜体验。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-700 mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      onClick={(e) => e.preventDefault()}
                      className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 51暗网吃瓜. 本站内容仅供娱乐参考，请理性吃瓜。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-400">合作伙伴</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}